import React from 'react';
import { Box } from '@material-ui/core';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
import NoteRoundedIcon from '@material-ui/icons/NoteRounded';
import { ANNOTATION_SOURCE_LOCATION, ANNOTATION_LOCATION } from '@backstage/catalog-model';
import gitUrlParse from 'git-url-parse';

const getSeverityBadge = (severityLevel, numberOfIssues) => {
  switch (severityLevel) {
    case "warning":
      return /* @__PURE__ */ React.createElement(
        Box,
        {
          display: "flex",
          alignItems: "center",
          fontWeight: "fontWeightLight",
          mr: 2,
          style: { color: "#f57c00" }
        },
        /* @__PURE__ */ React.createElement(WarningRoundedIcon, { fontSize: "small" }),
        "\xA0 ",
        numberOfIssues,
        " Warning"
      );
    case "error":
      return /* @__PURE__ */ React.createElement(
        Box,
        {
          display: "flex",
          alignItems: "center",
          fontWeight: "fontWeightLight",
          mr: 2,
          style: { color: "#d32f2f" }
        },
        /* @__PURE__ */ React.createElement(ErrorRoundedIcon, { fontSize: "small" }),
        "\xA0 ",
        numberOfIssues,
        " Error"
      );
    case "note":
      return /* @__PURE__ */ React.createElement(
        Box,
        {
          display: "flex",
          alignItems: "center",
          fontWeight: "fontWeightLight",
          mr: 2,
          style: { color: "#1976d2" }
        },
        /* @__PURE__ */ React.createElement(NoteRoundedIcon, { fontSize: "small" }),
        "\xA0 ",
        numberOfIssues,
        " Note"
      );
    default:
      return "Unknown";
  }
};
const getHostname = (entity) => {
  const location = entity?.metadata.annotations?.[ANNOTATION_SOURCE_LOCATION] ?? entity?.metadata.annotations?.[ANNOTATION_LOCATION];
  return location?.startsWith("url:") ? gitUrlParse(location.slice(4)).resource : void 0;
};

export { getHostname, getSeverityBadge };
//# sourceMappingURL=utils.esm.js.map
